var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VuePhoneNumberInput',{attrs:{"contenteditable":"true","no-validator-state":true},on:{"update":_vm.updateValue},model:{value:(_vm.valueModel),callback:function ($$v) {_vm.valueModel=$$v},expression:"valueModel"}})}
var staticRenderFns = []

export { render, staticRenderFns }